import ImageService from "@/services/image/image.service";

export const image = {
    namespaced: true,
    state: () => ({
        opened: false,
        currentIndex: 0
    }),
    mutations: {
        setOpened(state, value) {
            state.opened = value;
        },
        setCurrentIndex(state, value) {
            state.currentIndex = value;
        }
    },
    actions: {
        openGallery({ commit }, payload) {
            ImageService.openGallery(payload);
            ImageService.onChange(index => {
                commit("setCurrentIndex", index);
                }
            );
            ImageService.onClose(() => {
                    commit("setOpened", false);
                }
            );
            commit("setOpened", true);
        },
        closeGallery({ commit }) {
            ImageService.closeGallery();
            commit("setOpened", false);
        }
    }
};